<!-- bonus.wxml -->
<template>
    <div class="user-box">
        <div class="user-avatar" @click="editAvatar()">
            <div class="name">
                <span>头像</span>
            </div>
            <div class="img" v-if="userInfo.origin == 'h5'">
                <nut-uploader
                    name="iFile"
                    :url="url"
                    :acceptType="['image/jpeg', 'image/png', 'image/gif', 'image/bmp']"
                    :attach="formData"
                    @start="onStart"
                    @success="onSuccess"
                    typeError="对不起，不支持上传该类型文件！"
                    limitError="对不起，文件大小超过限制！"
                >
                    <img :src="avatarUrl" width="50" height="50" alt="头像">
                </nut-uploader>
            </div>
            <div class="img" v-else>
                <img :src="avatarUrl" width="50" height="50" alt="头像">
            </div>
        </div>
        <div class="user-text" @click="editPhone()">
            <div class="name">用户账号</div>
            <div class="text">
                {{userInfo.phone}}
            </div>
        </div>
        <div class="user-text" @click="editNickName()">
            <div class="name">昵称</div>
            <div class="text">
                {{userInfo.nickName}}
            </div>
        </div>
        <nut-popup :style="{ padding: '20px 30px',background:'#fff',borderRadius:'5px' }" v-model="show">
            <div class="nick-tips">请输入您的昵称</div>
            <input type="text" v-model="userInfo.nickName" class="nick-input" placeholder="请输入您的昵称">
            <div class="nick-btn" @click="qrEdit()">
                <div class="btn">确定修改</div>
            </div>
        </nut-popup>
        <div class="tips">温馨提示: 如需修改账户密码请先退出登陆然后点击忘记密码!</div>
        <nut-drag direction="y" :style="{right:'0px',bottom:'150px'}">
            <nut-fixednav active-text="收起导航" un-active-text="快速导航" :nav-list="NAVLIST" @selected="selectedNav"></nut-fixednav>
        </nut-drag>
    </div>
</template>
<script>
export default {
    name: 'EditUserInfo',
    data() { //默认数据
        return {
            userInfo: {
                nickName: '',
            },
            avatarUrl: '',
            url: '/api/upload/image',
            formData: {
                wxapp_id: 10001,
                token: this.$ls.get('token')
            },
            password: '',
            show: false,
        }
    },
    created() { //视图加载前执行
        let _this = this;
        this.loading = this.$toast.loading('Loading...', {
            coverColor: "rgba(0,0,0,0.5)",
        });
    },
    mounted() { //视图加载完成执行
        let _this = this;
        _this.getUserInfo();
    },
    methods: {

        // 获取用户信息
        getUserInfo() {
            let _this = this;
            _this._get('user.index/detail', {}, res => {
                _this.userInfo = res.data.userInfo
                _this.avatarUrl = res.data.userInfo.avatarUrl
                _this.avatarUrl = res.data.userInfo.avatarUrl
                _this.loading.hide();
            });
        },

        // 修改账号
        editPhone() {
            this.$toast.fail('用户账号不支持修改哦~');
        },

        // 修改头像
        editAvatar() {
            let _this = this;
            if (_this.userInfo.origin != 'h5') {
                _this.$toast.fail('抱歉,仅H5注册的用户支持头像修改!');
                return false;
            }
        },
        onStart(e) {
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
        },
        // 上传成功
        onSuccess(file, res) {
            let _this = this;
            let result = JSON.parse(res);
            this.avatarUrl = result.data.file_path;
            _this._post_form('user/editUserInfo', {
                avatarUrl: result.data.file_path
            }, res => {
                _this.loading.hide();
                _this.$toast.success('头像修改成功');
            });
        },

        editNickName() {
            let _this = this;
            if (_this.userInfo.origin != 'h5') {
                _this.$toast.fail('抱歉,仅H5注册的用户支持头像修改!');
                return false;
            }
            _this.show = true;
        },

        // 确定修改昵称
        qrEdit() {
            let _this = this;
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            _this._post_form('user/editUserInfo', {
                nickName: _this.userInfo.nickName
            }, res => {
                _this.loading.hide();
                _this.show = false;
                _this.$toast.success('昵称修改成功');
            });
        },

    },
    destroyed() {
        let _this = this;
        //切记页面销毁需要销毁
    }
}
</script>
<style lang="scss" scoped>
@import "edit_userinfo.scss";
</style>
